import React from 'react';
import { AppLogoStatic } from 'src/components/generic-components/AppLogo';
import { LOGO_PALETTES, LogoIcon } from 'src/components/dfp-home-page/top-navigation/LogoIcon';
import ARROW_ICON from '../../../../../images/arrow.svg';
import 'src/styles/dfp-home-page/dfp-top-navigation.scss';

interface EmbeddedNavPreviewProps {
  selectedLogoName: string | null;
  previewUrl: string | null;
  displayName: string;
}

const EmbeddedNavPreview: React.FC<EmbeddedNavPreviewProps> = ({ selectedLogoName, previewUrl, displayName }) => (
  <nav className="dfp-top-nav dfp-top-nav--preview" aria-label="Navigation preview">
    <div className="dfp-top-nav__left dfp-top-nav__left--embedded">
      <span className="dfp-top-nav__logo-link">
        <LogoIcon paletteIndex={LOGO_PALETTES.length - 1} className="dfp-top-nav__logo-icon" />
      </span>
      <img src={ARROW_ICON} alt="" className="dfp-top-nav__arrow" />
      <span className="dfp-top-nav__app_text">
        {(selectedLogoName || previewUrl) && (
          <span className="dfp-top-nav__app-logo-wrapper">
            <AppLogoStatic selectedLogoName={selectedLogoName} previewUrl={previewUrl} />
          </span>
        )}
        <span className="dfp-top-nav__app-name">{displayName.toLowerCase()}</span>
      </span>
    </div>
  </nav>
);

export default EmbeddedNavPreview;
